(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/match.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/match.js');

'use strict';

svs.matchen = svs.matchen || {};
svs.matchen.views = svs.matchen.views || {};

svs.matchen.views.Match = Marionette.View.extend({
  ui: {
    tabView: '.tab-view'
  },

  className: 'layout-draw-detail draw-detail',

  template: function(data) {
    return svs.matchen.templates.match(data);
  },

  regions: {
    drawHeader: '.region-draw-detail-header',
    couponBody: '.region-draw-detail-body',
    slider: '.matchen-slider-folder'
  },

  matchOddsToogle: true,

  initCoupon: function() {
    if (svs.core.detect.formfactor.mobile()) {
      this.tabs.push({
        caption: 'Odds',
        view: this.odds = new svs.matchen.views.MatchenOdds({
          model: this.model
        }),
        id: 'odds'
      });
    }
  },

  onResizeTabView: function() {
    var tabView =
        this.getRegion('couponBody') &&
        this.getRegion('couponBody').currentView;

    if (tabView) {
      tabView.resize();
    }
  },

  onAttach: function() {
    var tabView = new svs.app.tab_view.TabView({
      path: true,
      tabs: this.tabs,
      doNotSetHeight: false,
      el: this.ui.tabView[0],
      defaultTab: 'kupong',
      selected: this.options.tab,
      sliderOptions: {
        sliderDrag: Boolean(svs.core.detect.formfactor.mobile())
      }, 
      noDetectActiveTab: true,
      excludeActionBarHeight: true,
      excludeHeight: $('.region-draw-detail-header').outerHeight(true)
    });

    this.listenTo(tabView, 'onChange', this.onResizeTabView);

    window.onresize = this.onResizeTabView.bind(this);

    this.showChildView('couponBody', tabView);
    svs.core.data.title = {
      eventDescription: this.model.get('draw').get('eventDescription')
    };

    if (!svs.core.detect.formfactor.mobile()) {
      this.firstLoad();
    }
    this.renderBetslip();
    svs.matchen.views.betslip.initRelativeBetslip();
    setTimeout(function() {
      svs.matchen.views.betslip.betslipStickyBehaviour();
    }, 300);
  },

  renderBetslip: function() {
    var self = this;
    $('#betslip-wrapper').html(svs.matchen.views.betslip.render().el);

    svs.matchen.views.betslip.getRegion('betslipFooter').show(new svs.matchen.views.BetslipFooter({
      model: this.options.model
    }));
    svs.matchen.views.betslip.getRegion('betslipPayOptions').show(new svs.matchen.views.BetslipPayOptions({
      model: this.options.model
    }));
    svs.matchen.views.betslip.getRegion('betslipPay').show(new svs.matchen.views.PayFooter({
      model: this.options.model
    }));

    this.triggerScroll = function() {
      $('.js-swiper-container')
        .has('#coupon')
        .trigger('scroll');
      setTimeout(function() {
        svs.matchen.views.betslip.setWidth();
      }, 300);
    };
    this.triggerScroll = this.triggerScroll.bind(this);
    this.cancelDebounce = false;
    this.runBetslip = _.debounce(function() {
      if (!self.cancelDebounce) {
        svs.matchen.views.betslip.initRelativeBetslip();
        svs.matchen.views.betslip.betslipStickyBehaviour();
        self.triggerScroll();
      }
    }, 500);

    if (svs.core.detect.formfactor.desktop()) {
      $(window).on('resize', this.runBetslip);
    }

    this.listenTo(this.model.get('xperten'), 'change', this.runBetslip);
    this.listenTo(svs.matchen.tipsInfo, 'change', this.runBetslip);
  },

  onDestroy: function() {
    this.cancelDebounce = true;
    $(window).off('resize', this.runBetslip);
    this.stopListening(
      this.model.get('xperten'),
      'change',
      this.runBetslip
    );
    this.stopListening(svs.matchen.tipsInfo, 'change', this.runBetslip);

    if (this.tabs) {
      this.tabs = null;
      delete this.tabs;
    }

    if (this.$el) {
      this.$el.empty();
    }

    $('#matchen-odds-dimmer').removeClass('matchen-odds-dimmer-visible');
  },

  loadMatchOdds: function() {
    this.odds = new svs.matchen.views.MatchenOdds({ model: this.model });
    this.showChildView('slider', this.odds);
  },

  firstLoad: function() {
    this.loadMatchOdds();
  },

  destroyTabs: function() {
    _.each(this.tabs, function(tab) {
      if (tab && !tab.isDestroyed && !tab.isDestroyed()) {
        tab.destroy();
      }
      if (tab.caption == 'Kupong') {
        this.stopListening(tab);
      }
    });
  }
});


 })(window);